import { render } from "./AdminPagination.vue?vue&type=template&id=ae96f892"
import script from "./AdminPagination.vue?vue&type=script&lang=js"
export * from "./AdminPagination.vue?vue&type=script&lang=js"

import exportComponent from "/data/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__